import useTranslation from "next-translate/useTranslation";
import React, { FC } from "react";
import { colorImportant, colorPrimary } from "lib/constants";
import FormAttentionWrap from "./FormAttentionWrap";

interface Props {
  publicity: "yes" | "no";
}

const FormAttentionPublicity: FC<Props> = ({ publicity }) => {
  const { t } = useTranslation();
  return (
    <FormAttentionWrap
      color={publicity === "yes" ? colorPrimary[500] : colorImportant[500]}
    >
      {publicity === "yes" ? (
        <>{t("common:attention.public", {}, { fallback: "公開" })}</>
      ) : (
        <>{t("common:attention.private", {}, { fallback: "非公開" })}</>
      )}
    </FormAttentionWrap>
  );
};

export default FormAttentionPublicity;
